export default __webpack_public_path__ + "static/media/notif.0122a67e.mp3";